import React from 'react';

import { CRAFT_ROOT_ID } from 'craft/constants';
import { Section } from 'craft/containers/Toolbox/components';
import { SaveProgressToggle } from 'craft/resolvers/Flow/toolbox/SaveProgressToggle';

export const TourProgress = React.memo(() => {
  return (
    <Section name="Progress">
      <SaveProgressToggle nodeId={CRAFT_ROOT_ID} label="Tour" />
    </Section>
  );
});
